<template>
  <div class="cleanscore-bd" v-if="funcView.cleanscore_daily_list || funcView.cleanscore_histories_list">
    <div class="tab-box">
      <el-form :inline="true" @submit.native.prevent class="form-screen">
        <el-tabs v-model="statusState">
          <el-tab-pane :label="$t('cleanscore.jin_ri')" name="daily" v-if="funcView.cleanscore_daily_list"></el-tab-pane>
          <el-tab-pane :label="$t('cleanscore.li_shi')" name="historica" v-if="funcView.cleanscore_histories_list"></el-tab-pane>
        </el-tabs>
      </el-form>
    </div>
    <day-score v-if="statusState == 'daily'" ref="deviceTable"></day-score>
    <history-score v-if="statusState == 'historica'" ref="deviceTable"></history-score>
  </div>
</template>

<script>
import dayScore from './children/dayScore.vue';
import historyScore from './children/historyScore.vue';

export default {
  name: 'cleanscore',
  components: { dayScore, historyScore },
  data() {
    return {
      statusState: '',
    };
  },
  mounted: function () {
    this.getFuncView(null, () => {
      if (this.funcView.cleanscore_daily_list) {
        this.statusState = 'daily';
      } else if (this.funcView.cleanscore_histories_list) {
        this.statusState = 'historica';
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.cleanscore-bd {
  padding: 24px;
  .tab-box {
    .form-screen {
      overflow: hidden;
      line-height: 40px;
    }
    .icon-filter {
      display: inline-block;
      text-align: center;
      box-sizing: border-box;
      font-size: 14px;
      width: 40px;
      height: 40px;
      color: $--color-text-primary;
      box-shadow: 0 0 0 1.5px #202945 inset;
      border-radius: 50px;
      cursor: pointer;
    }
  }
  .box {
    & > .ub-f1 {
      height: 92px;
      border-radius: 16px;
      background-color: #ffffff;
      padding: 0 24px;
      margin-right: 24px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      .box-l {
        h1 {
          font-weight: bold;
          line-height: 17px;
          color: $--color-text-secondary;
          font-size: 12px;
        }
        p {
          margin-top: 4px;
          line-height: 30px;
          font-size: 22px;
          font-weight: bold;
        }
      }
      .box-r {
        height: 44px;
        width: 44px;
        line-height: 44px;
        border-radius: 44px;
        text-align: center;
        background-color: $--color-primary;
        .icon {
          font-size: 20px;
          color: #ffffff;
        }
      }
    }
  }
  .clean-info {
    height: 290px;
    margin-top: 24px;
    margin-bottom: 24px;
    .info {
      padding: 16px;
      border-radius: 16px;
      background-color: #ffffff;
      .ub-f1:first-child {
        padding: 16px;
      }
      h1 {
        font-weight: bold;
        font-size: 18px;
        line-height: 25px;
        color: $--color-text-primary;
      }
      h2 {
        margin-top: 20px;
        line-height: 45px;
        font-size: 32px;
        font-weight: bold;
        color: $--color-primary;
      }
      p {
        margin-top: 20px;
        font-weight: bold;
        line-height: 24px;
        color: $--color-text-secondary;
        span {
          color: $--color-primary;
        }
      }
      .btn {
        margin-top: 48px;
        display: inline-block;
        padding: 0 24px;
        height: 44px;
        border-radius: 30px;
        line-height: 44px;
        font-weight: bold;
        color: $--color-text-primary;
        background-color: $--color-warning;
        cursor: pointer;
        span {
          margin-right: 8px;
        }
        i.icon {
          font-size: 14px;
        }
      }
    }
    .banner {
      margin-left: 24px;
      width: 650px;
      border-radius: 16px;
      background-color: #ffffff;
      padding: 16px;
      border-radius: 16px;
      position: relative;
      img {
        display: block;
        width: 100%;
        border-radius: 12px;
      }
      &::before {
        content: '';
        position: absolute;
        left: 16px;
        right: 16px;
        top: 16px;
        bottom: 16px;
        border-radius: 12px;
        background: linear-gradient(360deg, rgba(32, 41, 69, 0.16) 0%, rgba(32, 41, 69, 0.88) 100%);
      }
    }
  }
  .select-date {
    h1 {
      font-size: 12px;
      line-height: 17px;
      font-weight: bold;
      color: $--color-primary;
      margin-bottom: 4px;
    }
    .el-input__prefix {
      color: $--color-primary;
      font-size: 18px;
      margin-right: 8px;
    }
    .el-input .el-input__inner {
      cursor: pointer;
      height: 40px;
      line-height: 41px;
      padding-left: 34px;
      font-weight: bold;
      color: $--color-text-primary;
    }
    .el-input__suffix {
      margin-right: 30px;
      .el-input__icon:after {
        font-family: 'icon' !important;
        content: '\E7F8';
        font-size: 22px;
        color: $--color-warning;
        margin-bottom: 2px;
      }
    }
  }
  // 表格
  .table-bd {
    margin-top: 24px;
    // 表头
    .table-head {
      display: flex;
      background-color: #fff;
      border-radius: 16px;
      padding: 0 24px;
      li {
        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          padding-right: 0;
        }
        height: 56px;
        line-height: 56px;
        padding-left: 10px;
        padding-right: 12px;
        color: $--color-text-secondary;
        span {
          font-weight: bold;
          font-size: 14px;
          color: $--color-text-secondary;
        }
      }
    }
    // 内容
    .table-body {
      .content {
        cursor: pointer;
        margin-top: 16px;
        height: 80px;
        line-height: 80px;
        border-radius: 16px;
        display: flex;
        padding: 0 24px;
        background-color: #fff;
        li {
          &:first-child {
            padding-left: 0;
          }
          &:last-child {
            padding-right: 0;
          }
          padding-left: 10px;
          padding-right: 12px;
          color: $--color-text-secondary;
          .item-icon i.icon {
            color: $--color-primary;
            font-size: 22px;
            margin-right: 8px;
          }
          span {
            color: $--color-text-regular;
            font-size: 14px;
            &.bold {
              font-weight: bold;
            }
          }
          span.fail {
            color: #eb5a5a;
          }
          .bar {
            height: 5px;
            border-radius: 5px;
            background: #f0f0f0;
            margin-top: 5px;
            div {
              height: 5px;
              border-radius: 5px;
              background: $--color-primary;
            }
          }
        }
        .el-button span {
          color: $--color-primary;
        }
      }
      // 无数据
      .no-data {
        margin-top: 24px;
        height: 130px;
        text-align: center;
        line-height: 130px;
        font-size: 16px;
        color: #818181;
        background: #ffffff;
        border-radius: 16px;
      }
    }
  }
  .table-footer {
    margin-top: 16px;
  }

  .site-wrapper {
    margin-top: 16px;
    background-color: #ffffff;
    border-radius: 16px;
    padding: 24px;
    .score {
      height: 40px;
      line-height: 40px;
      width: 60px;
      border-radius: 40px;
      background-color: #93da49;
      text-align: center;
      font-size: 18px;
      color: #ffffff;
      font-weight: bold;
      &.fail {
        background-color: #eb5a5a;
      }
    }
    .table-head {
      padding: 0;
      & > li:first-child span {
        padding-left: 24px;
      }
    }

    .table-body {
      .content {
        padding: 0;
        margin-top: 0;
        & > li:first-child > div {
          padding-left: 24px;
        }
      }
      & > li:nth-child(2n) ul {
        background-color: #f8f9fa;
      }
    }
  }
}
</style>
